module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "helpdesk"
  }, [_c('div', {
    staticClass: "helpdesk__hero"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "helpdesk__hero-inner"
  }, [_c('header', {
    staticClass: "helpdesk__topbar"
  }, [_c('div', {
    staticClass: "helpdesk__brand"
  }, [_c('a', {
    staticClass: "helpdesk__logo-link",
    attrs: {
      "href": _vm.homeUrl,
      "aria-label": "Docendo"
    }
  }, [_c('span', {
    staticClass: "helpdesk__logo-back"
  }, [_vm._v("← " + _vm._s(_vm.$t('vue2.helpdesk.back_to')))]), _vm._v(" "), _c('do-logo', {
    staticClass: "helpdesk__logo"
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "helpdesk__brand-name",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("Helpdesk")])]), _vm._v(" "), _c('div', {
    staticClass: "helpdesk__topbar-right"
  }, [_c('div', {
    staticClass: "helpdesk__langs",
    attrs: {
      "role": "group",
      "aria-label": _vm.$t('vue2.helpdesk.language')
    }
  }, _vm._l((_vm.localeOptions), function(opt) {
    return _c('button', {
      key: opt.code,
      staticClass: "helpdesk__lang",
      class: {
        'helpdesk__lang--active': _vm.locale === opt.code
      },
      attrs: {
        "type": "button",
        "aria-label": opt.label,
        "aria-pressed": _vm.locale === opt.code ? 'true' : 'false',
        "title": opt.label
      },
      on: {
        "click": function($event) {
          return _vm.setLocale(opt.code)
        }
      }
    }, [_c('img', {
      staticClass: "helpdesk__lang-flag",
      attrs: {
        "src": opt.flag,
        "alt": opt.label
      }
    })])
  }), 0)])]), _vm._v(" "), _c('p', {
    staticClass: "helpdesk__eyebrow"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.hero_eyebrow')))]), _vm._v(" "), _c('h1', {
    staticClass: "helpdesk__title"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.hero_title')))]), _vm._v(" "), _c('p', {
    staticClass: "helpdesk__subtitle"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.hero_subtitle')))]), _vm._v(" "), _c('div', {
    staticClass: "helpdesk__search"
  }, [_c('span', {
    staticClass: "helpdesk__search-icon icon-search5"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    ref: "searchInput",
    staticClass: "helpdesk__search-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('vue2.helpdesk.search_placeholder')
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }, _vm.onSearchInput],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.clearSearch.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.searchQuery) ? _c('button', {
    staticClass: "helpdesk__search-clear icon-cross2",
    attrs: {
      "type": "button",
      "aria-label": _vm.$t('vue2.helpdesk.clear_search')
    },
    on: {
      "click": _vm.clearSearch
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.showSubheader) ? _c('div', {
    staticClass: "helpdesk__subheader"
  }, [_c('div', {
    staticClass: "helpdesk__subheader-inner",
    class: {
      'helpdesk__subheader-inner--wide': !!_vm.activeArticle
    }
  }, [(_vm.activeArticle) ? [_c('span', {
    staticClass: "helpdesk__crumb-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.articles_about')))]), _vm._v(" "), (_vm.articleCategory) ? _c('a', {
    staticClass: "helpdesk__crumb-link",
    on: {
      "click": function($event) {
        return _vm.openCategory(_vm.articleCategory)
      }
    }
  }, [_vm._v(_vm._s(_vm.articleCategory))]) : _vm._e()] : [_c('button', {
    staticClass: "helpdesk__crumb-back",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeCategory
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left4"
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.helpdesk.back')) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "helpdesk__crumb-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.articles_about')))]), _vm._v(" "), _c('span', {
    staticClass: "helpdesk__crumb-pill"
  }, [_vm._v(_vm._s(_vm.activeCategory))]), _vm._v(" "), (_vm.categoryDescription(_vm.activeCategory)) ? _c('span', {
    staticClass: "helpdesk__crumb-desc"
  }, [_vm._v("\n          " + _vm._s(_vm.categoryDescription(_vm.activeCategory)) + "\n        ")]) : _vm._e()]], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "helpdesk__body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "helpdesk__container"
  }, [_vm._m(1)]) : (_vm.isSearching || _vm.searchQuery) ? _c('div', {
    staticClass: "helpdesk__container"
  }, [_c('button', {
    staticClass: "helpdesk__back",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left4"
  }), _vm._v("\n        " + _vm._s(_vm.$t('vue2.helpdesk.back_to_start')) + "\n      ")]), _vm._v(" "), _c('h2', {
    staticClass: "helpdesk__section-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.helpdesk.search_results')) + "\n        "), _c('span', {
    staticClass: "helpdesk__section-hint"
  }, [_vm._v("\"" + _vm._s(_vm.searchQuery) + "\"")])]), _vm._v(" "), (_vm.isSearching) ? _c('div', {
    staticClass: "helpdesk__loading helpdesk__loading--inline"
  }, [_c('div', {
    staticClass: "helpdesk__spinner"
  })]) : (_vm.searchResults.length) ? _c('ul', {
    staticClass: "helpdesk__article-list"
  }, _vm._l((_vm.searchResults), function(article) {
    return _c('li', {
      key: article.id,
      staticClass: "helpdesk__article-item",
      on: {
        "click": function($event) {
          return _vm.openArticle(article.id)
        }
      }
    }, [_c('span', {
      staticClass: "helpdesk__article-icon icon-file-text"
    }), _vm._v(" "), _c('span', {
      staticClass: "helpdesk__article-title"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('span', {
      staticClass: "helpdesk__article-arrow icon-arrow-right4"
    })])
  }), 0) : _c('p', {
    staticClass: "helpdesk__empty"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.no_results')))])]) : (_vm.activeArticle) ? _c('div', {
    staticClass: "helpdesk__container helpdesk__container--article"
  }, [_c('div', {
    staticClass: "helpdesk__layout"
  }, [_c('aside', {
    staticClass: "helpdesk__sidebar"
  }, [(_vm.articleCategory) ? _c('button', {
    staticClass: "helpdesk__back-pill",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCategory(_vm.articleCategory)
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left4"
  }), _vm._v(" "), _c('span', {
    staticClass: "helpdesk__back-pill-text"
  }, [_vm._v(_vm._s(_vm.articleCategory))])]) : _vm._e(), _vm._v(" "), (_vm.relatedArticles.length) ? [_c('h3', {
    staticClass: "helpdesk__sidebar-title"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.related_articles')))]), _vm._v(" "), _c('ul', {
    staticClass: "helpdesk__related-list"
  }, _vm._l((_vm.relatedArticles), function(article) {
    return _c('li', {
      key: article.id,
      staticClass: "helpdesk__related-item",
      on: {
        "click": function($event) {
          return _vm.openArticle(article.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(article.title) + "\n              ")])
  }), 0)] : _vm._e()], 2), _vm._v(" "), _c('article', {
    staticClass: "helpdesk__main helpdesk__article-card"
  }, [_c('div', {
    staticClass: "helpdesk__article-top"
  }, [_c('h1', {
    staticClass: "helpdesk__article-heading"
  }, [_vm._v(_vm._s(_vm.activeArticle.title))]), _vm._v(" "), _c('button', {
    staticClass: "helpdesk__share",
    class: {
      'helpdesk__share--done': _vm.shareCopied
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.shareArticle
    }
  }, [_c('span', {
    class: _vm.shareCopied ? 'icon-checkmark4' : 'icon-clipboard2'
  }), _vm._v("\n              " + _vm._s(_vm.shareCopied ? _vm.$t('vue2.helpdesk.link_copied') : _vm.$t('vue2.helpdesk.copy_link')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "helpdesk__article-body",
    domProps: {
      "innerHTML": _vm._s(_vm.articleHtml)
    }
  })])])]) : (_vm.activeCategory) ? _c('div', {
    staticClass: "helpdesk__container helpdesk__container--wide"
  }, [_c('div', {
    staticClass: "helpdesk__layout"
  }, [_c('aside', {
    staticClass: "helpdesk__sidebar"
  }, [_c('h3', {
    staticClass: "helpdesk__sidebar-title"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.categories')))]), _vm._v(" "), _c('ul', {
    staticClass: "helpdesk__sidebar-list"
  }, _vm._l((_vm.categories), function(cat) {
    return _c('li', {
      key: cat.name,
      staticClass: "helpdesk__sidebar-item",
      class: {
        'helpdesk__sidebar-item--active': cat.name === _vm.activeCategory
      },
      on: {
        "click": function($event) {
          return _vm.openCategory(cat.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(cat.name) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "helpdesk__main"
  }, [_vm._l((_vm.articlesInActiveCategory), function(article) {
    return _c('div', {
      key: article.id,
      staticClass: "helpdesk__result-card",
      on: {
        "click": function($event) {
          return _vm.openArticle(article.id)
        }
      }
    }, [_c('span', {
      staticClass: "helpdesk__result-icon icon-file-text"
    }), _vm._v(" "), _c('div', {
      staticClass: "helpdesk__result-content"
    }, [_c('h4', {
      staticClass: "helpdesk__result-title"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), (_vm.articleExcerpt(article)) ? _c('p', {
      staticClass: "helpdesk__result-excerpt"
    }, [_vm._v("\n                " + _vm._s(_vm.articleExcerpt(article)) + "\n              ")]) : _vm._e()])])
  }), _vm._v(" "), (!_vm.articlesInActiveCategory.length) ? _c('p', {
    staticClass: "helpdesk__empty"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.helpdesk.no_articles')) + "\n          ")]) : _vm._e()], 2)])]) : _c('div', {
    staticClass: "helpdesk__container helpdesk__home"
  }, [(_vm.featuredNews) ? _c('section', {
    staticClass: "helpdesk__news"
  }, [_c('div', {
    staticClass: "helpdesk__news-main"
  }, [_c('div', {
    staticClass: "helpdesk__news-top"
  }, [_c('span', {
    staticClass: "helpdesk__news-eyebrow"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.helpdesk.latest_news'))), (_vm.featuredNewsDate) ? [_vm._v(" · " + _vm._s(_vm.featuredNewsDate))] : _vm._e()], 2)]), _vm._v(" "), _c('h2', {
    staticClass: "helpdesk__news-title"
  }, [_vm._v(_vm._s(_vm.featuredNews.title))]), _vm._v(" "), _c('button', {
    staticClass: "helpdesk__news-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openArticle(_vm.featuredNews.id)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.helpdesk.read_news')) + "\n            "), _c('span', {
    staticClass: "icon-arrow-right4"
  })])]), _vm._v(" "), (_vm.olderNews.length) ? _c('div', {
    staticClass: "helpdesk__news-side"
  }, [_c('h3', {
    staticClass: "helpdesk__news-side-title"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.earlier_news')))]), _vm._v(" "), _c('ul', {
    staticClass: "helpdesk__news-list"
  }, _vm._l((_vm.olderNews), function(article) {
    return _c('li', {
      key: article.id,
      staticClass: "helpdesk__news-item",
      on: {
        "click": function($event) {
          return _vm.openArticle(article.id)
        }
      }
    }, [_vm._v("\n              " + _vm._s(article.title) + "\n            ")])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mostVisited.length) ? _c('section', {
    staticClass: "helpdesk__section"
  }, [_c('h2', {
    staticClass: "helpdesk__section-title"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.popular_articles')))]), _vm._v(" "), _c('ul', {
    staticClass: "helpdesk__popular"
  }, _vm._l((_vm.mostVisited), function(article) {
    return _c('li', {
      key: article.id,
      staticClass: "helpdesk__popular-item",
      on: {
        "click": function($event) {
          return _vm.openArticle(article.id)
        }
      }
    }, [_c('span', {
      staticClass: "helpdesk__popular-icon icon-file-text"
    }), _vm._v(" "), _c('span', {
      staticClass: "helpdesk__popular-title"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('span', {
      staticClass: "helpdesk__popular-arrow icon-arrow-right4"
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "helpdesk__section"
  }, [_c('div', {
    staticClass: "helpdesk__section-head"
  }, [_c('h2', {
    staticClass: "helpdesk__section-title"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.find_by_topic')))])]), _vm._v(" "), (_vm.topicCategories.length) ? _c('div', {
    staticClass: "helpdesk__grid"
  }, _vm._l((_vm.topicCategories), function(cat, index) {
    return _c('button', {
      key: cat.name,
      staticClass: "helpdesk__card",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openCategory(cat.name)
        }
      }
    }, [_c('span', {
      staticClass: "helpdesk__card-icon",
      class: {
        'helpdesk__card-icon--image': !!cat.icon
      }
    }, [(cat.icon) ? _c('img', {
      attrs: {
        "src": cat.icon,
        "alt": ""
      }
    }) : [_vm._v(_vm._s(index + 1))]], 2), _vm._v(" "), _c('span', {
      staticClass: "helpdesk__card-content"
    }, [_c('span', {
      staticClass: "helpdesk__card-title"
    }, [_vm._v(_vm._s(cat.name))]), _vm._v(" "), (cat.description) ? _c('span', {
      staticClass: "helpdesk__card-desc"
    }, [_vm._v(_vm._s(cat.description))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "helpdesk__card-count"
    }, [_vm._v("\n                " + _vm._s(cat.count) + " " + _vm._s(cat.count === 1 ? _vm.$t('vue2.helpdesk.article') : _vm.$t('vue2.helpdesk.articles')) + " →\n              ")])])])
  }), 0) : _c('p', {
    staticClass: "helpdesk__empty"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.no_articles')))])]), _vm._v(" "), _c('p', {
    staticClass: "helpdesk__footer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.helpdesk.footer_help')))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "helpdesk__hero-bg"
  }, [_c('div', {
    staticClass: "helpdesk__hero-bg__triangle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "helpdesk__loading"
  }, [_c('div', {
    staticClass: "helpdesk__spinner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44043770!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Helpdesk/Helpdesk.vue
// module id = 1885
// module chunks = 1